export enum KeyType {
  UNWRAP = 'unwrapKey',
  SIGNING = 'sign'
}

export interface UploadedKey {
  alg: string;
  d: string;
  dp: string;
  dq: string;
  e: string;
  key_ops: Array<KeyType>;
  kid: string;
  kty: string;
  n: string;
  p: string;
  q: string;
  qi: string;
}

export const isKeyOfType = (key: UploadedKey, type: KeyType): boolean => {
  if (key.key_ops === undefined) {
    return false;
  }

  return key.key_ops.includes(type);
};

export const isDecryptionKey = (key: UploadedKey): boolean => {
  return isKeyOfType(key, KeyType.UNWRAP);
};

export const isSigningKey = (key: UploadedKey): boolean => {
  return isKeyOfType(key, KeyType.SIGNING);
};

export interface OrganizationalUnit {
  name: string;
  ouId: string | null;
  destinationDtos: Array<Destination>;
  nameInFitConnect: string;
}

export interface Destination {
  destinationId: string;
  encryptionKid: string;
  privateSigningKey: UploadedKey | null; //
  privateDecryptionKey: UploadedKey | null; // Keymodel
  publicServiceTypeDto: Array<PublicServiceType>;
}
export interface PublicServiceType {
  identifier: string;
  submissionSchemaDtos: Array<SubmissionSchemaDto>;
}

export interface SubmissionSchemaDto {
  schemaUri: string;
  mimeType: string;
}

export interface ClientDestinationsModel {
  organizationalUnitDtos: Array<OrganizationalUnit>;
}

export const destinationsUrl: string = `/api/v1/configuration/destinations`;

export enum DestinationSources {
  fitconnect = 'FITCONNECT',
  newFitconnect = 'new-fitconnect'
}
